import React, { useCallback, useEffect, useState } from 'react'

import { Row, Col, Input, Form, FormGroup } from "reactstrap"
import { DetalleParametrosRegimenProyeccionHE } from '../TypesParametrosHorasExtras'
import { useParametrosHorasExtrasContext } from 'Context/ParametrosHorasExtrasContext'
import { useParametrosMensualesHorasExtrasContext } from 'Context/ParametrosMensualesHorasExtrasContext'

type PropsParametrosHorasPlanificacionRegimen = {
    idRegimenLaboral: number,
    nombreRegimen: string,
    parametros: DetalleParametrosRegimenProyeccionHE[] | null | undefined,
}

function ObtenerDetalleParametrosRegimen(idregimenlaboral: number, parametros: DetalleParametrosRegimenProyeccionHE[]) {

    if (parametros.length > 0) {
        const filtrados = parametros.filter(pr => pr.idregimenlaboral == idregimenlaboral)
        if (filtrados.length > 0) {
            return filtrados[0];
        }
        else {
            return undefined;
        }
    }
    else {
        return undefined;
    }



}

export default function ParametrosHorasPlanificacionRegimen(props: PropsParametrosHorasPlanificacionRegimen) {

    const { idRegimenLaboral, nombreRegimen, parametros } = props

    const [horasSuplementarias, sethorasSuplementarias] = useState<number | null>(null)
    const [horasExtraordinarias, sethorasExtraordinarias] = useState<number | null>(null)
    const [horasExtrYSupl, sethorasExtrYSupl] = useState<number | null>(null)


    const [checkHSupl, setcheckHSupl] = useState<boolean>(false)
    const [checkHExt, setcheckHExt] = useState<boolean>(false)
    const [checkHSuplExt, setcheckHSuplExt] = useState<boolean>(false)


    const {
        consultandoParametrosAnio
        , anioParametrosSeleccionado
        , creandoParametros
        , guardandoParametro
        , parametrosHorasRegimen
        , setparametrosHorasRegimen
    } = useParametrosMensualesHorasExtrasContext();

    const bloqueoGeneral = false

    useEffect(() => {


        if (parametros) {
            const parametrosDelRegimen = ObtenerDetalleParametrosRegimen(idRegimenLaboral, parametros)
            if (parametrosDelRegimen !== undefined) {
                sethorasExtraordinarias(parametrosDelRegimen.horasextraordinarias)
                sethorasSuplementarias(parametrosDelRegimen.horassuplementarias)
                sethorasExtrYSupl(parametrosDelRegimen.horassuplyextr)

                if (parametrosDelRegimen.horasextraordinarias && parametrosDelRegimen.horasextraordinarias > 0) {
                    setcheckHExt(true)
                }
                if (parametrosDelRegimen.horassuplementarias && parametrosDelRegimen.horassuplementarias > 0) {
                    setcheckHSupl(true)
                }

                if (parametrosDelRegimen.horassuplyextr && parametrosDelRegimen.horassuplyextr > 0) {
                    setcheckHSuplExt(true)
                }

            }
            else {
                sethorasSuplementarias(null);
                sethorasExtraordinarias(null);
                sethorasExtrYSupl(null);
            }


        }
        else {
            sethorasSuplementarias(null);
            sethorasExtraordinarias(null);
            sethorasExtrYSupl(null);
        }


    }, [parametros])





    const onChangeValue = useCallback(
        (valor: any, tipo: "supl" | "ext" | "suplyext") => {
            //var valor = e.target.value
            
            if (valor) {
                valor = +valor;
            }
            if (tipo === 'ext') {

                sethorasExtraordinarias(valor)
                setparametrosHorasRegimen((prev) => {

                    if (prev === null || (prev && prev.length === 0)) {
                        const nuevoParamRegimen: DetalleParametrosRegimenProyeccionHE[] = [{
                            horasextraordinarias: valor,
                            horassuplementarias: null,
                            horassuplyextr: null,
                            idregimenlaboral: props.idRegimenLaboral,
                            totalhoras: valor
                        }]
                        return nuevoParamRegimen;
                    }
                    else {
                        const indiceDeRegimenDeseado: number = prev.findIndex((v) => v.idregimenlaboral === props.idRegimenLaboral);
                        if (indiceDeRegimenDeseado === -1) {
                            const nuevoParamRegimen: DetalleParametrosRegimenProyeccionHE = {
                                horasextraordinarias: valor,
                                horassuplementarias: null,
                                horassuplyextr: null,
                                idregimenlaboral: props.idRegimenLaboral,
                                totalhoras: valor
                            }

                            return [...prev, nuevoParamRegimen]

                        }
                        else {
                            return (

                                prev.map((item) => {
                                    if (item.idregimenlaboral === props.idRegimenLaboral) {
                                        const copiaItem = { ...item }
                                        const nuevoTotal: number = valor + (copiaItem.horassuplementarias ?? 0)
                                        return ({ ...item, horassuplyextr: null, horasextraordinarias: valor, totalhoras: nuevoTotal })
                                    }
                                    return item

                                })
                            )
                        }

                    }





                })


            }
            else if (tipo === "supl") {
                sethorasSuplementarias(valor)
                setparametrosHorasRegimen((prev) => {

                    if (prev === null || (prev && prev.length === 0)) {
                        const nuevoParamRegimen: DetalleParametrosRegimenProyeccionHE[] = [{
                            horasextraordinarias: null,
                            horassuplementarias: valor,
                            horassuplyextr: null,
                            idregimenlaboral: props.idRegimenLaboral,
                            totalhoras: valor
                        }]
                        return nuevoParamRegimen;
                    }
                    else {
                        const indiceDeRegimenDeseado: number = prev.findIndex((v) => v.idregimenlaboral === props.idRegimenLaboral);
                        if (indiceDeRegimenDeseado === -1) {
                            const nuevoParamRegimen: DetalleParametrosRegimenProyeccionHE = {
                                horasextraordinarias: null,
                                horassuplementarias: valor,
                                horassuplyextr: null,
                                idregimenlaboral: props.idRegimenLaboral,
                                totalhoras: valor
                            }

                            return [...prev, nuevoParamRegimen]

                        }
                        else {
                            return (
                                prev.map((item) => {
                                    if (item.idregimenlaboral === props.idRegimenLaboral) {
                                        const copiaItem = { ...item }
                                        const nuevoTotal: number = valor + (copiaItem.horasextraordinarias ?? 0)
                                        return ({ ...item, horassuplyextr: null, horassuplementarias: valor, totalhoras: nuevoTotal })
                                    }
                                    return item


                                })
                            )
                        }
                    }




                })
            }
            else if (tipo === "suplyext") {
                sethorasExtrYSupl(valor)
                setparametrosHorasRegimen((prev) => {

                    if (prev === null || (prev && prev.length === 0)) {
                        const nuevoParamRegimen: DetalleParametrosRegimenProyeccionHE[] = [{
                            horasextraordinarias: null,
                            horassuplementarias: null,
                            horassuplyextr: valor,
                            idregimenlaboral: props.idRegimenLaboral,
                            totalhoras: valor
                        }]
                        return nuevoParamRegimen;
                    }
                    else {
                        const indiceDeRegimenDeseado: number = prev.findIndex((v) => v.idregimenlaboral === props.idRegimenLaboral);
                        if (indiceDeRegimenDeseado === -1) {
                            const nuevoParamRegimen: DetalleParametrosRegimenProyeccionHE = {
                                horasextraordinarias: null,
                                horassuplementarias: null,
                                horassuplyextr: valor,
                                idregimenlaboral: props.idRegimenLaboral,
                                totalhoras: valor
                            }

                            return [...prev, nuevoParamRegimen]

                        }
                        else {
                            return (
                                prev.map((item) => {
                                    if (item.idregimenlaboral === props.idRegimenLaboral) {
                                        return ({ ...item, horasextraordinarias: null, horassuplementarias: null, horassuplyextr: valor, totalhoras: valor })
                                    }
                                    return item


                                })
                            )
                        }
                    }

                })

            }


        }, [parametrosHorasRegimen]
    )

    function handleCheckboxChange(event: React.ChangeEvent<HTMLInputElement>) {

        const checked: boolean = event.target.checked;

        const name = event.target.name;
        if (name === "checkHSupl") {
            setcheckHSupl(checked)
            if (!checked) {
                sethorasSuplementarias(null)
                onChangeValue("", "supl")
            }
            else if (checkHSuplExt) {
                setcheckHSuplExt(false)
            }
        }
        else if (name === "checkHExt") {
            setcheckHExt(checked)
            if (!checked) {
                sethorasExtraordinarias(null)
                onChangeValue("", "ext")
            }
            else if (checkHSuplExt) {
                setcheckHSuplExt(false)
            }
        }
        else if (name === "checkHSuplExt") {
            setcheckHSuplExt(checked)
            if (!checked) {
                sethorasExtrYSupl(null)
                onChangeValue("", "suplyext")
            }
        }
    }

    console.log(parametrosHorasRegimen)

    return (
        <React.Fragment>
            <Row>
                <Col xl={12}>
                    <div className={props.nombreRegimen === "LOSEP" ? "tituloRegimenParamHorRegimPlanifLOSEP" : "tituloRegimenParamHorRegimPlanifCT"}>

                        {nombreRegimen}
                    </div>
                </Col>

            </Row>

            <Row className={"rowParamHorasProyRegimen"}>
                <Col xl={12} >

                    <Row className={"mt-3"}>
                        <Col xl={12}>
                            <div style={{ display: "flex", gap: "10px", alignItems: "center", justifyContent: "space-between" }}>
                                <div className={"labelParametrosHE"}> Máximo número de horas extras suplementarias</div>
                                <Input disabled={checkHSuplExt && (horasExtrYSupl ?? 0) > 0} type="checkbox" className="checkRegimenNroHorasExtras" checked={checkHSupl} name="checkHSupl" onChange={handleCheckboxChange}></Input>

                            </div>

                        </Col>
                        <Col xl={12}>
                            <Input
                                value={!horasSuplementarias ? "" : horasSuplementarias}
                                type="number"
                                disabled={bloqueoGeneral || guardandoParametro || creandoParametros || !checkHExt || (horasExtrYSupl ?? 0 > 0)}
                                onChange={(e) => onChangeValue(e.target.value, "supl")}
                            />

                        </Col>
                    </Row>

                    <Row>
                        <Col xl={12}>

                            <div style={{ display: "flex", gap: "10px", alignItems: "center", justifyContent: "space-between" }}>
                                <div className={"labelParametrosHE"}> Máximo número de horas extras extraordinarias</div>
                                <Input disabled={checkHSuplExt && (horasExtrYSupl ?? 0) > 0} type="checkbox" className="checkRegimenNroHorasExtras" checked={checkHExt} name="checkHExt" onChange={handleCheckboxChange}></Input>

                            </div>

                        </Col>

                        <Col xl={12}>
                            <Input
                                value={!horasExtraordinarias ? "" : horasExtraordinarias}
                                type="number"
                                disabled={bloqueoGeneral || guardandoParametro || creandoParametros || !checkHSupl || (horasExtrYSupl ?? 0 > 0)}
                                onChange={(e) => onChangeValue(e.target.value, "ext")}
                            />
                        </Col>
                    </Row>



                    <Row className={"mt-3"}>
                        <Col md={12}>

                            <div style={{ display: "flex", gap: "10px", alignItems: "center", justifyContent: "space-between" }}>
                                <div className={"labelParametrosHE"}>Máximo número de horas extras suplementarias y
                                    extraordinarias</div>
                                <Input disabled={checkHExt || checkHSupl} type="checkbox" className="checkRegimenNroHorasExtras" checked={checkHSuplExt} name="checkHSuplExt" onChange={handleCheckboxChange}></Input>

                            </div>
                        </Col>
                        <Col xl={12}>

                            <Input
                                value={!horasExtrYSupl ? "" : horasExtrYSupl}
                                type="number"
                                disabled={bloqueoGeneral || guardandoParametro || creandoParametros || !checkHSuplExt || ((horasExtraordinarias ?? 0 > 0) || (horasSuplementarias ?? 0 > 0))}
                                onChange={(e) => onChangeValue(e.target.value, "suplyext")}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>






        </React.Fragment>

    )
}
